// The MIT License (MIT)
//
// Copyright (c) 2024-2026 Camptocamp SA
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
export default `<span ng-if="::!layertreeCtrl.isRoot">{{::layertreeCtrl.node.name}}</span>
<input
  type="checkbox"
  ng-if="::layertreeCtrl.node && !layertreeCtrl.node.children"
  ng-model="layertreeCtrl.getSetActive"
  ng-model-options="{getterSetter: true}"
/>
<ul ng-if="::layertreeCtrl.node.children">
  <li
    ng-repeat="node in ::layertreeCtrl.node.children"
    gmf-layertree-node="::node"
    gmf-layertree-node-notroot
    gmf-layertree-node-map="layertreeCtrl.map"
    gmf-layertree-node-nodelayer="layertreeCtrl.nodelayerExpr"
    gmf-layertree-node-listenersexpr="layertreeCtrl.listenersExpr"
  ></li>
</ul>`;
//# sourceMappingURL=layertreeNode.html.js.map